import { EEnvironment } from "./app.config.types";
export var CONFIG_DEMO = {
    // Main
    ENVIRONMENT: EEnvironment.Demo,
    // Rentio API
    BASE_URL_V1: "https://api.demo.rentio-internal.be/v1",
    BASE_URL_V2: "https://api-next.demo.rentio-internal.be/v2",
    BASE_URL_SERVERLESS: "https://serverless.demo.rentio-internal.be",
    URL_SOCKETS: "wss://api.demo.rentio-internal.be/v1/websocket?access_token={{accessToken}}&locale={{locale}}",
    BASE_URL_INSURANCE: "https://dev.api.rentio-insurance.be/v1",
    // Google
    CAPTCHA_KEY: 
    // cspell:disable-next-line
    "6LcxNJokAAAAAO7A3tB4AGgq8GI-_4TXjjy0Bpuy",
    // Pay
    PAYMENT_LIMIT_AMOUNT_MESSAGE_DELAY: 3000,
    // Partners
    INSURANCE_TENANT_FLOW_URL: "https://dev.rentio-insurance.be",
    KEYPOINT_REPAIR_URL: "https://uat-case.keypoint.be",
};
